import { render } from "./VersionItem.vue?vue&type=template&id=0faa7b17"
import script from "./VersionItem.vue?vue&type=script&lang=js"
export * from "./VersionItem.vue?vue&type=script&lang=js"

import "./VersionItem.vue?vue&type=style&index=0&id=0faa7b17&lang=css"

import exportComponent from "C:\\Users\\DD6576\\tourbillon-timescale\\ui\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__